import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import requestApi from '../../utils/request2'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import { useAdminInfo } from '../../context/AdminContextDetail'
import CMSEditor from '../CMSEditor/CMSEditor'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ckeditor, { CKEditor } from '@ckeditor/ckeditor5-react'
import Swal from 'sweetalert2'
const CarbonReductionPlan = () => {
    const {
        register,
        reset,
        handleSubmit,
        setValue,
        formState: { errors },
        control
    } = useForm({})
    const currentAdminContext = useAdminInfo()
    const [currentCmsId, setCurrentCmsId] = useState()
    const [ckeditordata, setckeditordata] = useState(null)
    function handleCKEditor(event, editor) {
        const data = editor.getData()
        setckeditordata(data)
    }
    async function getTermsandcondition() {
        return requestApi(
            'GET',
            `/cms/list`,
            {},
            { slug: 'carbonreductionplan' },
            true
        ).then((res) => {
            setCurrentCmsId(res?.data?.data?.cmsId)
            setckeditordata(res?.data?.data)
            return res.data.data
        })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['CMSlist'],
        queryFn: getTermsandcondition
    })
    const [editorState, seteditorState] = useState()
    async function addEditTermsandConditions(payload) {
        return requestApi(
            'POST',
            `/cms/add-edit`,
            { ...payload, cmsId: currentCmsId, title:"carbonreductionplan" },
            { },
            true
        )
    }

    const editMutation = useMutation(addEditTermsandConditions, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    const onEditSubmit = (data) => {
        const payload = {
            description: ckeditordata
        }
        editMutation.mutate(payload)
    }

    return (
        <CMSEditor>
            <div className="myaccount-sidebar-content policy-page privacy-policy">
                <div className="page-content admin-policy">
                    <Form onSubmit={handleSubmit(onEditSubmit)}>
                        <div className="title-text">
                            <h3>Carbon Reduction Plan</h3>
                            <ButtonWithLoader cssClass="common-btn comman-auth-btn reset-btn">
                                <Button
                                    className="common-btn save-btn"
                                    type="submit"
                                >
                                    Save
                                </Button>
                            </ButtonWithLoader>
                        </div>
                        <div className="policy">
                            <CKEditor
                                data={
                                    ckeditordata?.description
                                        ? ckeditordata?.description
                                        : ckeditordata
                                }
                                editor={ClassicEditor}
                                config={{
                                    removePlugins: [
                                        'EasyImage',
                                        'ImageUpload',
                                        'MediaEmbed'
                                    ],
                                    allowedContent: true,
                                    extraAllowedContent: true,
                                    toolbar: [
                                        'heading',
                                        '|',
                                        'bold',
                                        'italic',
                                        'link',
                                        'bulletedList',
                                        'numberedList',
                                        // "blockQuote",
                                        // 'ckfinder',
                                        '|',
                                        // 'imageTextAlternative',
                                        // 'imageUpload',
                                        // 'imageStyle:full',
                                        // 'imageStyle:side',
                                        // '|',
                                        // 'mediaEmbed',
                                        'insertTable',
                                        // "tableColumn",
                                        // "tableRow",
                                        // "mergeTableCells",
                                        '|',
                                        'undo',
                                        'redo'
                                    ]
                                }}
                                onReady={(editor) =>
                                    // ckeditordata.description
                                    console.log(editor, 'hello')
                                }
                                onChange={handleCKEditor}
                            />
                        </div>
                    </Form>
                </div>
            </div>
        </CMSEditor>
    )
}

export default CarbonReductionPlan
